import { Model } from "./Model";
import { required } from "vuelidate/lib/validators";

class Tipo extends Model {
  constructor() {
    super();
    this.descricao = "";
  }
}

const TipoValidation = {
  descricao: {
    required,
  },
};

const TipoNoValidation = {
  descricao: {},
};

export { Tipo, TipoValidation, TipoNoValidation };
